import React from "react";
import "../style/Home.css";
import { Box, Link, Typography } from "@mui/material";
import { LinkedInIcon, MailIcon } from "../assets";

const Home = () => {
  const [hover, setHover] = React.useState(false);
  const [linkedInHover, setLinkedInHover] = React.useState(false);

  const handleOpenMail = () => {
    const mailtoLink = "mailto:yogeshyadavyj@gmail.com";
    window.location.href = mailtoLink;
  };

  return (
    <Box px={{ xs: 4, sm: 10, lg: 20 }}>
      <Box id="" py={{ xs: 15, sm: 15, lg: 24 }} textAlign={"left"}>
        <Typography
          variant="h1"
          fontFamily={"M PLUS 1, sans-serif"}
          fontSize={{ xs: "3rem", sm: "6rem", lg: "10rem" }}
          sx={{
            display: "flex",
            flexDirection: "column",
            fontOpticalSizing: "auto",
            fontWeight: 335,
          }}
        >
          <span>Hello I'm</span>Yogesh Yadav
        </Typography>
        <Typography
          variant="h4"
          fontSize={{ xs: "1.2rem", sm: "1.7rem", lg: "2rem" }}
          py={{ xs: 2.5, sm: 4, lg: 8 }}
          width={{ sm: "100%", lg: "83%" }}
          // mb={{sm: 5, lg: 0}}
          fontWeight={330}
        >
          Bridging code and creativity,
          <span>
            I sculpt products with precision—a Product Manager with a BTech in
            CSE, turning ideas into seamless digital experiences.
          </span>
        </Typography>
      </Box>

      <Box id="AboutMe" textAlign={"left"}>
        <Typography
          variant="h1"
          fontFamily={"M PLUS 1, sans-serif"}
          fontSize={{ xs: "3rem", sm: "4.5rem", lg: "6rem" }}
        >
          About Me
        </Typography>
        <Typography
          variant="h4"
          fontFamily={"M PLUS 1, sans-serif"}
          py={5}
          sx={{
            fontWeight: 300,
            fontSize: { xs: "1.2rem", sm: "1.7rem", lg: "2.15rem" },
          }}
        >
          As a highly motivated and detail-focused graduate, I am excited to
          embark on a dynamic professional journey where I can apply my
          research, study, and technical prowess. Armed with a robust
          understanding of agile methodologies, blockchain, and product
          management, I am ready to play a pivotal role in successfully
          launching innovative products and catalyzing positive transformations
          for existing product lines. My adeptness at discerning market trends
          positions me as a proactive force in informing strategic
          decision-making. I am fervently eager for the opportunity to
          continuously learn and grow, actively seeking mentorship to further
          hone and propel my career in a vibrant and forward-thinking
          environment.
        </Typography>

        <Box display={"flex"} gap={"20px"}>
          <Box
            component={"div"}
            sx={{
              borderRadius: "28px",
              backgroundColor: "#000",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
              cursor: "pointer",
              // width: "14%",
            }}
            display={"flex"}
            px={1}
            py={1}
            onClick={handleOpenMail}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <Link
              sx={{
                display: "flex",
                width: "fit-content",
                textDecoration: "none",
                color: "#fff",
                fontSize: { xs: ".8rem", sm: "1.2rem" },
                fontWeight: 700,
                paddingLeft: "4px",
              }}
            >
              Write to me{" "}
            </Link>
            <Box
              display={"flex"}
              width={"40px"}
              height={"40px"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Box
                sx={{
                  width: hover ? "40px" : "10px",
                  height: hover ? "40px" : "10px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  overflow: "hidden",
                  transition: "all .2s ease-in-out",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {hover && (
                  <img
                    src={MailIcon}
                    alt="linkedInYogesh"
                    style={{
                      width: "60%",
                      height: "60%",
                      objectFit: "contain",
                      alignSelf: "center",
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>

          <Box
            component={"div"}
            sx={{
              borderRadius: "28px",
              backgroundColor: "#000",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
              cursor: "pointer",
              // width: "12%",
            }}
            display={"flex"}
            px={1}
            py={1}
            onClick={() => {
              window.location.href =
                "https://www.linkedin.com/in/yogesh-yadavyy/";
            }}
            onMouseEnter={() => setLinkedInHover(true)}
            onMouseLeave={() => setLinkedInHover(false)}
          >
            <Link
              sx={{
                display: "flex",
                width: "fit-content",
                textDecoration: "none",
                color: "#fff",
                fontSize: { xs: ".8rem", sm: "1.2rem" },
                fontWeight: 700,
                paddingLeft: "4px",
              }}
            >
              LinkedIn{" "}
            </Link>
            <Box
              display={"flex"}
              width={"40px"}
              height={"40px"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Box
                sx={{
                  width: linkedInHover ? "40px" : "10px",
                  height: linkedInHover ? "40px" : "10px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  transition: "all .2s ease-in-out",
                }}
              >
                {linkedInHover && (
                  <img
                    src={LinkedInIcon}
                    alt="linkedInYogesh"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
